<template>
  <div
    class="config-form-content weeducAdminIntegrations adminWeeducConfig weeduc-admin-config weeduc-admin-integrations"
  >
    <div class="weeduc-admin-integrations__intro">
      <h3 class="weeduc-admin-integrations__title">Integrações</h3>
      <p class="weeduc-admin-integrations__lead">
        Pixels, tags de medição e códigos de automação (RD Station) conectados ao seu site.
      </p>
    </div>

    <Loader :isActive="hasReady" />

    <div class="row g-3 g-lg-4 weeduc-admin-config-layout mx-0" v-if="hasReady">
      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">Pixels e medição</h3>
          <p class="weeduc-admin-config-section-lead">
            Facebook, Google Ads, Analytics e Google Tag Manager.
          </p>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationFacebook">Facebook Pixel</label>
            <input
              id="weeducIntegrationFacebook"
              v-model="facebook"
              type="text"
              class="form-input"
              placeholder="Ex.: ID do pixel"
              autocomplete="off"
            />
            <small class="form-small-description">
              Código para rastrear e analisar o comportamento dos visitantes.
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationGads">Google Ads Pixel</label>
            <input
              id="weeducIntegrationGads"
              v-model="gads"
              type="text"
              class="form-input"
              placeholder="Ex.: AW-XXXXXXXXX / conversão"
              autocomplete="off"
            />
            <small class="form-small-description">
              Código para monitorar conversões de anúncios.
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationGa">Google Analytics</label>
            <input
              id="weeducIntegrationGa"
              v-model="ganalytic"
              type="text"
              class="form-input"
              placeholder="Ex.: G-XXXXXXXXXX"
              autocomplete="off"
            />
            <small class="form-small-description">
              Código para acompanhar acessos e interações no site.
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationGtm">Google Tag Manager</label>
            <input
              id="weeducIntegrationGtm"
              v-model="tagManager"
              type="text"
              class="form-input"
              placeholder="Ex.: GTM-XXXXXXX"
              autocomplete="off"
            />
            <small class="form-small-description">
              Container para gerenciar e ativar tags no site.
            </small>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 weeduc-admin-config-col">
        <div class="weeduc-admin-config-section">
          <h3 class="weeduc-admin-config-section-title">RD Station</h3>
          <p class="weeduc-admin-config-section-lead">
            Integração com automação e CRM (quando aplicável ao seu plano).
          </p>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdRefresh">RDRefresh</label>
            <input
              id="weeducIntegrationRdRefresh"
              v-model="rdrefreshToken"
              type="text"
              class="form-input"
              placeholder="Token RDRefresh"
              autocomplete="off"
            />
            <small class="form-small-description">
              Código RDRefresh para integrar marketing digital e automação.
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdCode">RD Station — código</label>
            <input
              id="weeducIntegrationRdCode"
              v-model="rdcode"
              type="text"
              class="form-input"
              placeholder="Código da integração"
              autocomplete="off"
            />
            <small class="form-small-description">
              Código RD Station para manter a integração e automações atualizadas.
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdSecret">RD Station — secret (client)</label>
            <input
              id="weeducIntegrationRdSecret"
              v-model="rdSecret"
              type="text"
              class="form-input"
              placeholder="Client secret"
              autocomplete="off"
            />
            <small class="form-small-description">
              Chave secreta de autenticação do RD Station.
            </small>
          </div>

          <div class="form-group">
            <label class="form-label" for="weeducIntegrationRdClient">RD Station — client ID</label>
            <input
              id="weeducIntegrationRdClient"
              v-model="rdClient"
              type="text"
              class="form-input"
              placeholder="Client ID"
              autocomplete="off"
            />
            <small class="form-small-description">
              Identificador do cliente para conectar ao RD Station.
            </small>
          </div>
        </div>
      </div>
    </div>

    <div class="buttons-container weeduc-admin-site-form-actions">
      <div class="button d-flex flex-wrap gap-2 justify-content-end" v-show="hasSite">
        <button type="button" class="btn btn-block btn-content" @click="save()">
          Salvar Edição e Publicar
        </button>
        <button type="button" class="btn btn-block btn-content" @click="clearCache()">
          Limpar Cache
        </button>
      </div>
      <div class="button" v-show="!hasSite">
        <button type="button" class="btn btn-block btn-content" @click="save()">
          Criar e Publicar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/site'
import apiSiteIntegration from '@/utils/Site/integrations'
import { mapState } from 'vuex'
import Loader from '@/components/Loader/loader.vue'
import { toast } from 'vue3-toastify'

export default {
  name: 'WeeducAdminIntegrations',
  components: {
    Loader,
  },
  props: {
    saved: Boolean,
  },
  data() {
    return {
      hasSite: false,
      facebook: '',
      tagManager: '',
      ganalytic: '',
      gads: '',
      rdSecret: '',
      rdClient: '',
      rdcode: '',
      rdrefreshToken: '',
      id: null,
      hasSaved: false,
      hasReady: false,
      windowWidth: window.innerWidth,
    }
  },
  computed: {
    ...mapState(['token']),
  },
  methods: {
    async getConfigSite() {
      try {
        const response = await apiSiteIntegration.getIntegrationData(this.token)
        this.hasSite = true
        this.tagManager = response.tagManagerCode ?? ''
        this.ganalytic = response.googleAnalyticsCode ?? ''
        this.facebook = response.facebookPixelCode ?? ''
        this.gads = response.googleAdsCode ?? ''
        this.rdSecret = response.rdsecretClient ?? ''
        this.rdClient = response.rdclienteId ?? ''
        this.rdcode = response.rdcode ?? ''
        this.rdrefreshToken = response.rdrefreshToken ?? ''
        this.hasReady = true
      } catch (error) {
        toast.error('Erro ao carregar as configurações do site')
        console.error('Erro ao carregar as configurações do Site', error)
        this.hasReady = true
      }
    },
    async editSite() {
      this.hasReady = false
      const obj = {
        tagManagerCode: this.tagManager,
        googleAnalyticsCode: this.ganalytic,
        facebookPixelCode: this.facebook,
        googleAdsCode: this.gads,
        rdsecretClient: this.rdSecret,
        rdclienteId: this.rdClient,
        rdcode: this.rdcode,
        rdrefreshToken: this.rdrefreshToken,
      }
      try {
        await apiSiteIntegration.putIntegrationData(this.token, obj)
        await this.getConfigSite()
        toast.success('Configurações do site editadas com sucesso!')
      } catch (error) {
        toast.error('Erro ao editar as configurações do site.')
        console.error('Erro ao Editar Site', error)
        this.hasReady = true
      }
    },
    async clearCache() {
      try {
        await api.clearCache(this.token)
        toast.success('Cache limpo com sucesso!')
      } catch (error) {
        toast.error('Erro ao limpar cache.')
        console.error(error)
      }
    },
    save() {
      this.editSite()
      this.hasSaved = true
    },
  },
  created() {
    this.getConfigSite()
  },
}
</script>

<style scoped>
@import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
@import '@/css/weeduc/admin/config.css';
@import '@/css/weeduc/admin/integrations.css';
</style>
